import { createFileRoute } from '@tanstack/react-router';

import { Loader } from '@/components';
import { LandingPage } from '@/pages';

export const Route = createFileRoute('/(dashboard)/layouts/$id')({
  loader: ({ params }) => ({ id: params.id }),
  pendingComponent: () => <Loader />,
  component: LandingPage,
});
